const meta = {
  'kubernetes-cluster': 'Kubernetes',
  linux: 'Linux',
};

export default meta;
